export default __webpack_public_path__ + "static/media/bella-ramsey_6_finale.4d4da684.jpg";